<footer class="westnetz-footer">

  <img src="/assets/innogy-icons/westnetz_combined_p_RGB.svg">

  <div class="copyright-links-row">
    <div class="copyright-section">
      <span class="text">© Westnetz {{ currentYear }}</span>
    </div>

    <div class="links-section">
      <a class="link text" target="_blank" href="https://www.westnetz.de/de/impressum.html"
         data-qa="legal-disclosure">Impressum</a>
      <a class="link text" target="_blank" href="https://www.westnetz.de/de/datenschutz.html"
         data-qa="privacy-policy">Datenschutz</a>
    </div>
  </div>
</footer>
